import { writable, get } from 'svelte/store';
import { regex } from 'uuidv4';
import moment from 'moment';

// {
//   first_name: { value: residents.first_name, validators: ["required", "min:6"]}
// }
export const form = (rules) => {
  const result = writable(intialize(rules()));
  const { subscribe, set, update } = result;

  return {
    subscribe, set, update,
    validate: () => {
      return {
        update(node) {
          validate(rules(), result);
        }
      }
    },
    clear: () => {}
  }
}

const validate = async (rules, result) => {
  const resultStore = get(result);
  const fields = Object.keys(rules);
  fields.forEach(field => {
    // { value: residents.first_name, validators: ["required", "min:6"]}
    const { value, validators} = rules[field];
    if (value != resultStore[field].old) {
      const errors = validateField(value, validators);
      result.update(current => {
        const updatedFields = Object.assign(
          current, 
          { 
            [field]: {
              errors: errors, 
              old: value, 
              valid: !errors.length,
              dirty: true,
            }
          },
        )
        return {
          ...updatedFields,
          valid: isFormValid(Object.assign(updatedFields))
        }
      }); 
    }
  });
}

const validateField = (value, validators) => {
  let errors = [];
  if (!validators.includes('required') && !value) return errors;
  validators.forEach(validator => {
    const validatorAndArgs = validator.split(':');
    if (!rulesContext[validatorAndArgs[0]](value, validatorAndArgs.slice(1))) errors.push(validatorAndArgs[0]);
  });
  return errors;
}

const isFormValid = (result) => {
  return Object.keys(result)
    .filter(key => key !== 'valid')
    .every(key => result[key].valid);
}

const intialize = (rules) => {
  let result = {}
  Object.keys(rules).forEach(key => {
    const validateErrors = validateField(rules[key].value, rules[key].validators);
    result[key] = {
      errors: validateErrors, 
      old: rules[key].value, 
      valid: !validateErrors.length,
      dirty: false
    }
  });
  result.valid = isFormValid(result);
  return result;
}

// validation rules
const rulesContext = {
  // required
  required: (val, args) => {
    let isValid = true;

    if (val === undefined || val === null) isValid = false;
  
    if (typeof val === 'string') {
      const tmp = val.replace(/\s/g, "");
  
      if (tmp.length === 0) isValid = false;
    }
    return isValid;
  },

  // min:10
  // if number, checks number greater or equal
  // if string, checks length greater or equal
  min: (val, args) => {
    const minValue = parseFloat(args[0]);
    const value = isNaN(val) ? val.length : parseFloat(val);
    return value >= minValue;
  },

  // max:10 
  // if number, checks number less than or equal
  // if string, checks length less or equal
  max: (val, args) => {
    const maxValue = parseFloat(args[0]);
    const value = isNaN(val) ? val.length : parseFloat(val);
  
    return isNaN(value) ? true : value <= maxValue;
  },

  // between:1:8 
  // if number, checks value between inclusive
  // if string, checks length inclusive
  between: (val, args) => {
    return min(val, [args[0]]) && max(val, [args[1]]);
  },

  // email
  email: (val, args) => {
    const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  
    return val && regex.test(val);
  },

  // equal:10
  // if number, checks number is equal to
  // if string, checks length is equal to number
  equal: (val, args) => {
    return val === args[0];
  },

  // url
  url: (val, args) => {
    const regex = /(https?|ftp|git|svn):\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i;
    return regex.test(val);
  },

  // phone ((111)1112222, 111-222-3333, 111 222 3333)
  phone: (val, args) => {
    const regex = /^\(?[\d]{3}\)?[\s-]?[\d]{3}[\s-]?[\d]{4}$/;
    return regex.test(val);
  },

  // postal (55449, 55449-0909, G3H 6A6)
  postal: (val, args) => {
    const regex = /^\d{5}-\d{4}|\d{5}|[A-Z]\d[A-Z] \d[A-Z]\d$/;
    return regex.test(val);
  },

  // date mm/dd/yyyy and after yesterday
  date: (val) => {
    const date = moment(val, 'YYYY-MM-DD')
    return date.isValid() && date.isAfter(moment().subtract(1, 'day'),'day');
  }
}




// https://github.com/chainlist/svelte-forms/blob/master/src/index.js

